import { axiosInstance } from "@abb-connect/react-shared";
import { useQuery } from "@tanstack/react-query";
import { UseQueryResult } from "@tanstack/react-query";

export function useIsAbbUserApi(): UseQueryResult<boolean> {
  return useQuery<boolean>({
    queryKey: ["isAbbUser"],
    queryFn: async (): Promise<boolean> => {
      const url = "/users/me/abb";
      return (await axiosInstance.get<boolean>(url)).data;
    },
    staleTime: Infinity,
  });
}

export function useIsUserAdminApi(): UseQueryResult<boolean> {
  return useQuery<boolean>({
    queryKey: ["isUserAdmin"],
    queryFn: async (): Promise<boolean> => {
      const url = "/users/me/admin";
      return (await axiosInstance.get<boolean>(url)).data;
    },
    staleTime: Infinity,
  });
}
